import { error, info, success } from "App/popupMessage/redux/actionCreators";
import signalR from "Common/signalR";
import forEach from "lodash/forEach";
import actionTypes from "./actionTypes";
import locale from "./signalRMiddleware.locale";
const handler = (store, actionType) => (message) => {
    store.dispatch({ type: actionType, message });
};
const signalRMiddleware = (store) => {
    signalR.start(() => store.dispatch(error(locale.CONNECTION_CLOSE_WARNING, false, {
        className: "btn-primary",
        title: locale.RECONNECT,
        icon: "icon-refresh font-h5 mr-0_25",
        onClick: () => {
            signalR.reconnect();
        }
    })), () => store.dispatch(info(locale.CONNECTION_RETRY_INFO, false)), () => store.dispatch(success(locale.CONNECTION_RETRY_SUCCESS, false)));
    forEach(actionTypes, actionType => {
        signalR.subscribe(actionType.signalR, handler(store, actionType.redux));
    });
    return (next) => (action) => next(action);
};
export default signalRMiddleware;
